import React, { FC, memo, useEffect, useRef, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { staticMultimedia, TStaticMultimedia } from 'utils'

import styles from './styles.module.scss'

interface IProps {
  name: string,
  width?: string
  link: string
}

export const NewResource: FC<IProps> = memo(({ name, width, link }) => {

  const handleClick = () => {
    link && window.open(link, '_blank', 'noopener,noreferrer')
  }

  const logoUrl = staticMultimedia[name as TStaticMultimedia]

  return (
    <button className={styles.newResourceBox} onClick={handleClick}>
      <div className={styles.newResourceBoxInner}>
        <img className={styles.logo}
             style={{
               // @ts-ignore
               '--newResourceLogoLogoWidth': width ? width : '85%'
             }}
             src={logoUrl as string}
             alt="logo"/>
      </div>

    </button>
  )
})
